import { useCallback, useEffect, useRef, useState } from 'react';

import { useDispatch } from '@lumapps/redux/react';

import { actions } from '../ducks/slice';

/** Hook to get the article dialog open state and toggle it. */
export const useArticleDialog = () => {
    const dispatch = useDispatch();
    const dialogTriggerRef = useRef<HTMLButtonElement>(null);
    const [isArticleDialogOpen, setIsArticleDialogOpen] = useState(false);

    const openArticleDialog = useCallback(() => setIsArticleDialogOpen(true), []);

    const closeArticleDialog = useCallback(() => {
        setIsArticleDialogOpen(false);
        dispatch(actions.clearEditedArticle());
    }, [dispatch]);

    /** Closing the dialog and clearing edited article on component unmount */
    useEffect(
        () => () => {
            if (isArticleDialogOpen) {
                dispatch(actions.clearEditedArticle());
            }
        },
        [dispatch, isArticleDialogOpen],
    );

    return {
        isOpen: isArticleDialogOpen,
        openArticleDialog,
        closeArticleDialog,
        dialogTriggerRef,
    };
};
